import { TFunction } from 'i18next';
import { CountMarkTypes } from '@lib/components/CountMark/CountMark';
import { TabBarItem, TabBarItemTypes } from '@lib/components/TabBar/constants';
import { ApprovalsTab } from '../enums';

type Args = {
  approvalsCounterData?: {
    all?: number;
    onValidation?: number;
    rejected?: number;
    validated?: number;
  };
  t: TFunction<'translation', undefined>;
};

export default function getApprovalsTabs({
  approvalsCounterData,
  t,
}: Args): TabBarItem[] {
  return [
    {
      label: t('all'),
      value: ApprovalsTab.All,
      counter: approvalsCounterData?.all,
    },
    {
      label: t('on-validation'),
      value: ApprovalsTab.OnValidation,
      counter: approvalsCounterData?.onValidation,
      counterType: CountMarkTypes.orange,
      type: TabBarItemTypes.orange,
    },
    {
      label: t('rejected'),
      value: ApprovalsTab.Rejected,
      counter: approvalsCounterData?.rejected,
      counterType: CountMarkTypes.red,
      type: TabBarItemTypes.red,
    },
    {
      label: t('validated'),
      value: ApprovalsTab.Validated,
      counter: approvalsCounterData?.validated,
      counterType: CountMarkTypes.green,
      type: TabBarItemTypes.green,
    },
  ];
}
